var map = {
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./password.svg": "QjmH",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./video.svg": "3JNx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 47